import { NumberUtils } from '../utils';
import { CerebroIcon, CerebroHeading } from '.';

export const DebtCapitalHeading: React.FC<DebtCapitalHeadingProps> = ({ icon: Icon, children, amountRequested }) => {
	return (
		<CerebroHeading size="h2" component="h2" sx={{ display: 'flex', alignItems: 'center', marginBottom: 3 }}>
			<CerebroIcon sx={{ paddingRight: 1 }}>
				<Icon width="32" height="32" />
			</CerebroIcon>
			{children} {amountRequested !== 0 ? `- ${NumberUtils.FormatCurrency(amountRequested)} Requested` : ''}
		</CerebroHeading>
	);
};

interface DebtCapitalHeadingProps {
	icon: React.ElementType;
	amountRequested: number;
}
